exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.submitted .form-control.ng-invalid,\r\n.submitted .errorField,\r\n:host >>> .submitted .ng-invalid .ui-calendar .ui-inputtext,\r\n:host >>> .submitted .ng-invalid .ui-dropdown .ui-dropdown-label {\r\n    border-color: #DE6D31 !important;\r\n    background-color: #ffe7e7;\r\n    transition: .3s;\r\n}\r\n\r\n.input-group{\r\n    width: 300px;\r\n}\r\n\r\n.button-submit-forgot{\r\n    margin-left: 11em;\r\n}\r\n\r\n.caution_txt {\r\n    font-size: 12px;\r\n    font-style: italic;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/confirmpassword/confirmpassword.component.css
// module id = 1009
// module chunks = 1